/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IExpeditionRepository } from "@/interface/expedition";

const expeditionRepository: IExpeditionRepository = {
  /**
   * Função para buscar expedições
   * @param accessToken
   * @returns Promise<any | null>
   */
  async getAllExpedition<T>(
    accessToken: string,
    currentPage: number = 1,
    itemsPerPage: number = 10,
    searchItem: ""
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const expedicoes = await Instance.get(
      `remessas/tarefas-expedicoes?page=${currentPage}&per_page=${itemsPerPage}&search=${searchItem}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return expedicoes?.data;
  },
};

/**
 * EXPORTS
 */
export { expeditionRepository };
